import { getWebInstrumentations, initializeFaro } from '@grafana/faro-web-sdk'
import { TracingInstrumentation } from '@grafana/faro-web-tracing'

export function setupFaro(): void {
  const faroUrl = import.meta.env.VITE_FARO_URL
  const appName = import.meta.env.VITE_APP_NAME || 'system-req-checker-frontend'
  const appEnv = import.meta.env.VITE_APP_ENV || 'dev'

  if (!faroUrl) {
    return
  }

  initializeFaro({
    url: faroUrl,
    app: {
      name: appName,
      version: '1.0.0',
      environment: appEnv
    },
    instrumentations: [
      ...getWebInstrumentations({
        captureConsole: true,
        captureConsoleDisabledLevels: []
      }),
      new TracingInstrumentation({
        instrumentationOptions: {
          // Propaga traceparent para todos os backends da stack
          // Isso cria o link browser → backend no Tempo
          propagateTraceHeaderCorsUrls: [
            /https:\/\/.*\.educacional\.(com|app|com\.br)/,
            /https:\/\/.*\.pensemais\.com\.br/,
            /https:\/\/.*\.edurl\.com\.br/
          ]
        }
      })
    ],
    sessionTracking: {
      enabled: true,
      samplingRate: 1 // 100% — volume baixo, pode manter
    }
  })
}
